import { ReactElement, useState } from "react";
import { cloneElement } from "react";
import { useTranslation } from "react-i18next";

type ValueItem = {
  valueLabel: string;
  value: string | number;
  valueUnit?: string;
};

type ParameterItemProps = {
  icon: React.ElementType;
  title: string;
  valueItems: ValueItem[];
  modal: ReactElement;
};

export const ParameterItem = ({ icon: Icon, title, valueItems, modal }: ParameterItemProps) => {
  const { t } = useTranslation("boClients");
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="flex w-full max-w-[600px] flex-col gap-2 rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex flex-row justify-between gap-4">
        <div className="flex w-fit flex-row items-center gap-4">
          <Icon className="text-black" width={24} height={24} />
          <h3 className="text-lg font-semibold text-black">{title}</h3>
        </div>
        <div className="flex flex-row items-center gap-4">
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="bg-brand50 text-brand700 h-fit w-fit rounded-lg px-4 py-2 text-sm font-semibold hover:bg-blue-100 focus:outline-hidden"
          >
            {t("clientParameters.edit")}
          </button>
        </div>
      </div>
      {valueItems.map((item, index) => (
        <div
          key={index}
          className="flex flex-row items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4"
        >
          <p className="text-xs font-medium text-gray-500">{item.valueLabel}</p>
          <p className="text-sm font-medium text-gray-900">
            {item.value}
            {item.valueUnit}
          </p>
        </div>
      ))}
      {showModal && cloneElement(modal, { closeModal: () => setShowModal(false) })}
    </div>
  );
};
